<span class="help-tip" [class.is-open]="open">
  <button
    type="button"
    class="help-tip-trigger"
    [attr.aria-expanded]="open"
    [attr.aria-label]="
      label ||
      (hasTextKey ? (textKey | translate) : text) ||
      ('common.help' | translate)
    "
    (click)="toggle($event)"
  >
    <fa-icon icon="circle-info"></fa-icon>
  </button>
  @if (open) {
    <span class="help-tip-bubble" role="tooltip">
      @if (hasTextKey) {
        {{ textKey | translate }}
      } @else {
        {{ text }}
      }
    </span>
  }
</span>
